import type { HTMLAttributes } from "react";

export function ViewTitle2({ children, ...props }: HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h1 className="tw:mb-0! tw:text-3xl! tw:font-bold tw:max-md:mt-3! tw:md:mt-6!" {...props}>
      {children}
    </h1>
  );
}
